/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useContext} from 'react';
import {TableWrapperContext} from './TableWrapper';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import InputSearch from '../../shared/InputSearch';

const Search = ({
  title = 'Поиск...',
  searchParameters = ['id', 'name'],
  actions = () => {},
  isBeSearch = false,
  style = {},
}) => {
  const theme = useResolvedThemeMode();
  const {tableData, setFoundItems} = useContext(TableWrapperContext);

  const [string, setString] = useState('');
  const [firstRendering, setFirstRendering] = useState(true);

  useEffect(() => {
    if (isBeSearch) return;

    if (!!firstRendering) return setFirstRendering(false);
    if (!string) return setFoundItems(null);
    const val = string.trim().toLowerCase();

    const sortedArray = tableData
      .filter((item) => item.parentId === null)
      .filter((item) => {
        const matchCount = searchParameters.reduce((count, parameter) => {
          const value = String(item[parameter]).toLowerCase();
          return count + (value.includes(val) ? 1 : 0);
        }, 0);
        return matchCount > 0;
      })
      .sort((a, b) => {
        const countA = searchParameters.reduce((count, parameter) => {
          const value = String(a[parameter]).toLowerCase();
          return count + (value.includes(val) ? 1 : 0);
        }, 0);

        const countB = searchParameters.reduce((count, parameter) => {
          const value = String(b[parameter]).toLowerCase();
          return count + (value.includes(val) ? 1 : 0);
        }, 0);

        return countB - countA;
      });

    setFoundItems(sortedArray.map((item) => item.compositeId));
  }, [string]);

  const handleChange = (e) => {
    const {value} = e.target;
    setString(value);
    actions();
  };

  return (
    <div className='d-flex align-items-center position-relative mb-5 mb-sm-5 mb-md-0'>
      <i className='ki-duotone ki-magnifier fs-3 position-absolute ms-5'>
        <span className='path1'></span>
        <span className='path2'></span>
      </i>
      <input
        type='text'
        className='form-control form-control-solid w-100 mw-250px ps-13'
        placeholder={title}
        value={string || ''}
        onChange={handleChange}
        style={{
          backgroundColor: theme === 'dark' ? 'rgba(15, 16, 21, 1)' : 'rgba(245, 246, 247, 1)',
          height: '40px'
          // ...style,
        }}
      />
    </div>
  );
};

export default Search;
